import { render } from "./Toolbar.vue?vue&type=template&id=3e7cefc1&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"

import "./Toolbar.vue?vue&type=style&index=0&id=3e7cefc1&lang=scss&scoped=true"
import "./Toolbar.vue?vue&type=style&index=1&id=3e7cefc1&lang=scss"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7cefc1"]])

export default __exports__